module.exports = __webpack_public_path__ + "99951cef1a91d5394bbd5dd8798d879d.svg";